document.addEventListener('bundler:loaded', function (e) {
  window.bndlr.updateCartDiscounts();
});

// Listen to the custom event for recalculated cart values
document.addEventListener('bundler:total_cart_values', function (e) {
  // Extract the relevant values from the event detail with safe checks
  const {
    total_amount_original = 0,
    total_amount_discounted = 0,
    discount_amount = 0,
    discounted_cart_object = null,
  } = e.detail;

  // Update the cart subtotal (without VAT)
  const subtotalWithoutTaxElement = document.getElementById('cart-price_subtotal');
  const subtotalWithoutTax = (total_amount_discounted / 1.21 / 100).toFixed(2).replace('.', ','); // Assume 21% VAT
  if (subtotalWithoutTaxElement) {
    subtotalWithoutTaxElement.textContent = `${subtotalWithoutTax} €`;
  }

  // Update the total tax element
  const totalTaxElement = document.getElementById('cart-price_tax');
  const totalTax = (total_amount_discounted / 100 - total_amount_discounted / 1.21 / 100).toFixed(2).replace('.', ','); // Correct VAT calculation
  if (totalTaxElement) {
    totalTaxElement.textContent = `${totalTax} €`;
  } else {
    totalTaxElement.textContent = `0,00 €`; // Fallback if calculation fails
  }

  // Update the total discount element
  const totalDiscountElement = document.getElementById('cart-price_discount');
  const totalDiscount = (discount_amount / 100).toFixed(2).replace('.', ',');
  if (totalDiscountElement) {
    totalDiscountElement.textContent = `-${totalDiscount} €`;
  }

  console.log('totalDiscount', discount_amount);
  if (discount_amount > 0) {
    console.log('jaaaaaaaaa');
    document.querySelectorAll('[data-cart-discount').forEach((e) => {
      e.classList.add('flex');
      e.classList.remove('hidden');
      console.log(e);
    });
  } else {
    console.log('neeeeee');
    document.querySelectorAll('[data-cart-discount').forEach((e) => {
      console.log(e);
      e.classList.remove('flex');
      e.classList.add('hidden');
      console.log(e);
    });
  }

  // Update the total price element
  const totalPriceElement = document.getElementById('cart-price_total');
  const totalPrice = (total_amount_discounted / 100).toFixed(2).replace('.', ',');
  if (totalPriceElement) {
    totalPriceElement.textContent = `${totalPrice} €`;
  }

  // Update the shipping progress bar and text
  const shippingThreshold = 500; // 1499 euros
  const currentTotal = total_amount_discounted / 100; // Convert cents to euros
  const progressBarElement = document.getElementById('shipping-progress-bar');
  const shippingMessageElement = document.getElementById('shipping-message');
  const shippingCostElement = document.getElementById('cart-shipping_amount');
  const shippingCostElementContainer = document.getElementById('cart-shipping_amount-container');

  const checkoutButton = document.querySelector(`.cart__checkout-button`);

  console.log('ship');
  // console.log(shippingThresholdLeftElement);
  console.log(shippingMessageElement);

  if (progressBarElement) {
    const progressPercentage = Math.min((currentTotal / shippingThreshold) * 100, 100);
    progressBarElement.style.width = `${progressPercentage}%`;
  }

  // if (shippingThresholdLeftElement && shippingMessageElement) {
  // console.log(shippingThresholdLeftElement);
  if (currentTotal < shippingThreshold) {
    console.log('currentTotal', currentTotal);
    console.log('shippingThreshold', shippingThreshold);
    const amountLeft = (shippingThreshold - currentTotal).toFixed(2).replace('.', ',');
    shippingMessageElement.innerHTML = `Um Ihre Bestellung abzuschließen, müssen Sie noch Artikel im Wert von 
        <span class="font-bold" id="shipping-threshold-left">
        ${amountLeft}
        </span>
        zu Ihrem Warenkorb hinzufügen.`;
    const shippingThresholdLeftElement = document.getElementById('shipping-threshold-left');
    shippingThresholdLeftElement.textContent = `${amountLeft} €`;
    if (shippingCostElement) {
      shippingCostElementContainer.classList.add('hidden');
      shippingCostElement.textContent = '150,00 €';
    }

    checkoutButton.classList.add('disabled-link');
    checkoutButton.innerHTML = `Nog ${amountLeft} € hinzufügen`;
  } else {
    shippingMessageElement.innerHTML = `Sie haben <span class="font-bold text-accent">kostenlosen</span> Versand erreicht!`;
    if (shippingCostElement) {
      shippingCostElementContainer.classList.remove('hidden');
      shippingCostElement.textContent = 'Gratis';
    }

    checkoutButton.classList.remove('disabled-link');
    checkoutButton.innerHTML = `Weiter zur Bestellung`;
  }
  // }

  // Update individual cart items
  if (discounted_cart_object && discounted_cart_object.items) {
    discounted_cart_object.items.forEach((item) => {
      console.log(item);
      // Find the relevant cart item element by its variant ID or another unique identifier
      const itemElement = document.querySelector(`[data-cart-variant="${item.variant_id}"]`);

      let variant;
      fetch(`/products/${item.handle}.js`)
        .then((response) => response.json())
        .then((product) => {
          variant = product.variants.filter((v) => v.title == item.variant_title)[0];
          console.log('pvariant', variant);
        });

      if (itemElement) {
        // Update the original price display
        const oldPriceElement = itemElement.querySelector('[data-old-price]');
        if (oldPriceElement) {
          oldPriceElement.textContent = `${((variant.compare_at_price * item.quantity) / 100)
            .toFixed(2)
            .replace('.', ',')} €`;
        }
        // Update the new price display
        const newPriceElement = itemElement.querySelector('[data-new-price]');
        if (newPriceElement) {
          newPriceElement.textContent = `${(item.line_price / 100).toFixed(2).replace('.', ',')} €`;
        }

        if (!oldPriceElement) return false;

        if (variant && variant.compare_at_price * item.quantity > item.line_price) {
          oldPriceElement.style.display = 'block';
        } else {
          oldPriceElement.style.display = 'none';
        }
      } else {
        console.warn(`Cart item element not found for variant ID: ${item.variant_id}`);
      }
    });
  } else {
    console.warn('Discounted cart object is undefined or missing items.');
  }
});

// Dispatch initial event to initialize cart values
var cartEvent = new CustomEvent('bundler:total_cart_values', {
  detail: {
    total_amount_original: 0, // Initialize with default or dummy value
  },
});
document.dispatchEvent(cartEvent);

function increaseQuantity(event, id) {
  event.preventDefault();
  console.log('increase quantity', id);

  document.querySelector(`quantity-input[id="Quantity-${id}"] .quantity__button[name="plus"]`).click();
}
function decreaseQuantity(event, id) {
  event.preventDefault();
  console.log('decrease quantity', id);

  document.querySelector(`quantity-input[id="Quantity-${id}"] .quantity__button[name="minus"]`).click();
}
